var _circle, _path, _ellipse, _ellipse2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji38(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#EA596E",
    cx: 18,
    cy: 18,
    r: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M26.125 29.261c-.028 0-.057-.003-.084-.01-8.424-1.942-15.996-.022-16.072-.002-.111.028-.231.005-.324-.066-.091-.072-.145-.181-.145-.297 0-3.178 3.713-6.872 8.5-6.872s8.5 3.694 8.5 6.872c0 .114-.052.223-.142.294-.067.052-.149.081-.233.081zM29 12c-5.554 0-7.802-4.367-7.895-4.553-.247-.494-.047-1.095.447-1.342.493-.247 1.092-.048 1.34.443C22.967 6.694 24.713 10 29 10c.553 0 1 .448 1 1s-.447 1-1 1zM7 12c-.552 0-1-.448-1-1s.448-1 1-1c5.083 0 5.996-3.12 6.033-3.253.145-.528.692-.848 1.219-.709.53.139.851.673.718 1.205C14.921 7.437 13.704 12 7 12z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#292F33",
    cx: 12,
    cy: 16.5,
    rx: 2.5,
    ry: 3.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#292F33",
    cx: 24,
    cy: 16.5,
    rx: 2.5,
    ry: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4ABBA",
    d: "M18.629 23.079v.827l-1.091.001v-.837c-2.277.127-4.191 1.162-5.455 2.516l.008.461c.086 2.932 2.08 5.802 5.992 5.802 3.899 0 5.892-2.851 5.991-5.773l.009-.284c-1.229-1.415-3.145-2.537-5.454-2.713z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M18 23.049c-.157 0-.308.014-.462.022v4.447c0 .301.244.545.545.545s.545-.244.545-.545V23.08c-.207-.017-.414-.031-.628-.031z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5DADEC",
    d: "M35.906 12.062c0 2.814-2.28 5.094-5.094 5.094-2.814 0-5.094-2.28-5.094-5.094s4.075-10.188 5.094-10.188 5.094 7.375 5.094 10.188zM8.573 8.438c0 2.313-1.875 4.188-4.188 4.188-2.313 0-4.188-1.875-4.188-4.188S3.547.063 4.385.063s4.188 6.062 4.188 8.375z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji38);
export default __webpack_public_path__ + "static/media/emoji38.8d8c6e709f745052d92f3784c68dd11b.svg";
export { ForwardRef as ReactComponent };